export function isUndefinedOrEmptyArray<T = unknown>(array: T[] | undefined | null): boolean {
  return !Array.isArray(array) || array.length === 0;
}

if (import.meta.vitest) {
  const { test, expect } = import.meta.vitest;

  test("isUndefinedOrEmptyArray", () => {
    expect(isUndefinedOrEmptyArray(undefined)).toBe(true);
    expect(isUndefinedOrEmptyArray(null)).toBe(true);
    expect(isUndefinedOrEmptyArray([])).toBe(true);
    expect(isUndefinedOrEmptyArray([1, 2, 3])).toBe(false);
    expect(isUndefinedOrEmptyArray([undefined])).toBe(false);
    expect(isUndefinedOrEmptyArray([null])).toBe(false);
    expect(isUndefinedOrEmptyArray([undefined, null])).toBe(false);
  });
}
